/**
 * パスワードリセットページ用のスクリプト
 * @uses 管理画面と設計が異なるため共通部分は呼び出すもののamc独自イベントなどは使用しない。
 */
if (is_route('password.forgot')) {

    $(function () {

        // 確認コード送信ボタンクリック時
        $(document).on('click', '#password-forgot-form-submit', function () {
            let formId = '#password-forgot-form';
            // 送信
            _ajax.submit(formId, function (response) {
                if(response.status){
                    location.href = response.url;
                }
            }, function(xhr, status, errorThrown){
                // エラーをセットする
                _error.set(formId, xhr, status, errorThrown, false);
            });
            return false;
        });

    });
}

if (is_route('password.authentication_form')) {

    $(function () {

        // 確認ボタンクリック時
        $(document).on('click', '#password-authentication-form-submit', function () {
            let formId = '#password-authentication-form';
            // 送信
            _ajax.submit(formId, function (response) {
                if(response.status){
                    location.href = response.url;
                }
            }, function(xhr, status, errorThrown){
                // エラーをセットする
                _error.set(formId, xhr, status, errorThrown, false);
            });
            return false;
        });

        // 確認コード再送信ボタンクリック時
        $(document).on('click', '#password-authentication-form-reissue', function () {
            let action = $(this).data('action');
            let datas = { 'id' : $(this).data('id') };
            // 送信
            _ajax.post(action, datas,  function (response) {
                // 完了メッセージをセットする
                _complete.set(response);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
            return false;
        });

    });
}

// ログイン画面に戻るボタンクリック時
$(document).on('click', '.password-reset-cancel', function () {
    location.href = $(this).data('action');
});